import { QUERY_STRING_PARAM_STRATEGY } from './constants';

export const isBrowser = () => typeof window !== 'undefined';

export const getLocationPath = () =>
  isBrowser() ? window.location.pathname : null;

export const getLocationQS = () =>
  isBrowser() ? window.location.search : null;

export const getLocationQueryStringParam = (
  param: string,
  strategy:
    | QUERY_STRING_PARAM_STRATEGY.STRING
    | QUERY_STRING_PARAM_STRATEGY.ARRAY = QUERY_STRING_PARAM_STRATEGY.ARRAY
) => {
  if (!isBrowser()) {
    return strategy === QUERY_STRING_PARAM_STRATEGY.STRING ? '' : [];
  }

  const qs = new URLSearchParams(window.location.search);
  const stringValue = decodeURIComponent(qs.get(param) || '');

  if (strategy === QUERY_STRING_PARAM_STRATEGY.STRING) {
    return stringValue;
  }

  return stringValue ? stringValue.split(',') : [];
};

export const generateLocationQueryString = (params: {
  [key: string]: string | string[] | null;
}) => {
  if (!isBrowser()) {
    return '';
  }

  const urlSearchParams = new URLSearchParams(getLocationQS() as string);

  Object.entries(params).forEach(([param, value]) => {
    if (value === null || !value.length) {
      urlSearchParams.delete(param);
    } else {
      const paramValue = Array.isArray(value)
        ? value.map(encodeURIComponent).join(',')
        : value;

      urlSearchParams.set(param, decodeURIComponent(paramValue));
    }
  });

  const search = urlSearchParams.size
    ? `?${decodeURIComponent(urlSearchParams.toString())}`
    : '';
  const path = getLocationPath();

  return `${path}${search}`;
};

export const prepareClassName = (name: string) =>
  String(name).replace(/\s/g, '-').toLowerCase();
